import React from "react";
import {useTranslation} from "react-i18next";

import useDialog from "../../../components/useDialog";

import MDButton from "materialDashboard/components/MDButton";
import MDBox from "materialDashboard/components/MDBox";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import MDTypography from "../../../materialDashboard/components/MDTypography";
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import {useCreateModel1ExportTask, useModel1ExportMutation} from "../query";
import MDLoadingButton from "../../../components/MDLoadingButton";
import WorkgroupAutocomplete from "../../../components/inputs/WorkgroupsAutocomplete/WorkgroupAutocomplete";
import {Alert} from "@mui/material";
import ExportTaskDialogContent from "../../../components/ExportTaskDialogContent";


const useExportState = ({close, models1Filters}) => {
    const [format, setFormat] = React.useState("PDF");

    const model1SyncExportMutation = useModel1ExportMutation();
    const model1AsyncExportMutation = useCreateModel1ExportTask({async: true});

    const [exportTaskId, setExportTaskId] = React.useState(null);

    const [workgroupId, setWorkgroupId] = React.useState(null);

    // State to manage asynchronous export option, in case of async export then the app should go
    // in polling mode to check the status of the export
    const [asyncExport, setAsyncExport] = React.useState(false);

    const handleClose = () => {
        close();
        setExportTaskId(null);
    }

    const handleExport = async () => {
        if (asyncExport) {
            const data = await model1AsyncExportMutation.mutateAsync({
                workgroupId: workgroupId,
                filters: models1Filters,
                data: {format}
            });
            setExportTaskId(data.id);
        } else{
            await model1SyncExportMutation.mutateAsync({...models1Filters, format});
            close();
        }
    }

    const handleChangeFormat = (event) => {
        setFormat(event.target.value);
    };

    const handleChangeAsyncExport = (event) => {
        setAsyncExport(event.target.value === 'true');
    }

    const handleChangeWorkgroupId = (newValue) => {
        setWorkgroupId(newValue);
    }

    return {
        format,
        handleChangeFormat,
        handleExport,
        asyncExport,
        handleChangeAsyncExport,
        model1SyncExportMutation,
        isLoading: model1SyncExportMutation.isLoading || model1AsyncExportMutation.isLoading,
        handleChangeWorkgroupId,
        workgroupId,
        exportTaskId,
        handleClose
    }
}


const ExportDialog = ({isOpen, close, models1Filters={}}) => {

    const exportState = useExportState({close, models1Filters});

    return <Dialog onClose={exportState.handleClose} open={isOpen} maxWidth="lg" fullWidth>
        {
            exportState.exportTaskId === null ?
                <ExportModel1DialogContent exportState={exportState}/>
                :
                <ExportTaskDialogContent exportTaskId={exportState.exportTaskId} handleClose={exportState.handleClose}/>
        }
    </Dialog>
}


const ExportModel1DialogContent = ({exportState}) => {
    const {t} = useTranslation(["models1", "validation"]);
    return <>
        <DialogTitle>{t('export.title')}</DialogTitle>
        <DialogContent>
            {t('export.description')}

            <FormControl fullWidth>
                <RadioGroup
                    name="format"
                    value={exportState.format}
                    onChange={exportState.handleChangeFormat}
                >
                    <Grid container>
                        <Grid item xs={12} sm={6}>
                            <div>
                                <FormControlLabel value="CSV" control={<Radio/>} label={<MDBox>
                                    <MDTypography variant="body2">
                                        MODELLO1 - CSV v2025
                                    </MDTypography>
                                </MDBox>}/>
                            </div>
                            <div>
                                <FormControlLabel value="PDF" control={<Radio/>} label={<MDBox>
                                    <MDTypography variant="body2">
                                        MODELLO1 - PDF v2025
                                    </MDTypography>
                                </MDBox>}/>
                            </div>
                        </Grid>
                        {/*<Grid item xs={12} sm={6}>*/}
                        {/*    <div>*/}
                        {/*        <FormControlLabel value="CSV_LEGACY" control={<Radio/>} label={<MDBox>*/}
                        {/*            <MDTypography variant="body2">*/}
                        {/*                MODELLO1 - CSV legacy*/}
                        {/*            </MDTypography>*/}
                        {/*            <MDTypography variant="caption" color="warning">*/}
                        {/*                Deprecato a partire dal 1 settembre 2026*/}
                        {/*            </MDTypography>*/}
                        {/*        </MDBox>}/>*/}
                        {/*    </div>*/}
                        {/*    <div>*/}
                        {/*        <FormControlLabel value="PDF_LEGACY" control={<Radio/>} label={<MDBox>*/}
                        {/*            <MDTypography variant="body2">*/}
                        {/*                MODELLO1 - PDF legacy*/}
                        {/*            </MDTypography>*/}
                        {/*            <MDTypography variant="caption" color="warning">*/}
                        {/*                Deprecato a partire dal 1 settembre 2026*/}
                        {/*            </MDTypography>*/}
                        {/*        </MDBox>}/>*/}
                        {/*    </div>*/}
                        {/*    <div>*/}
                        {/*        <FormControlLabel value="TXT_LEGACY" control={<Radio/>} label={<MDBox>*/}
                        {/*            <MDTypography variant="body2">*/}
                        {/*                MODELLO1 - TXT legacy*/}
                        {/*            </MDTypography>*/}
                        {/*            <MDTypography variant="caption" color="warning">*/}
                        {/*                Deprecato a partire dal 1 settembre 2026*/}
                        {/*            </MDTypography>*/}
                        {/*        </MDBox>}/>*/}
                        {/*    </div>*/}
                        {/*    <div>*/}
                        {/*        <FormControlLabel value="ZRX_LEGACY" control={<Radio/>} label={<MDBox>*/}
                        {/*            <MDTypography variant="body2">*/}
                        {/*                MODELLO1 - ZRX legacy*/}
                        {/*            </MDTypography>*/}
                        {/*            <MDTypography variant="caption" color="warning">*/}
                        {/*                Deprecato a partire dal 1 settembre 2026*/}
                        {/*            </MDTypography>*/}
                        {/*        </MDBox>}/>*/}
                        {/*    </div>*/}
                        {/*</Grid>*/}
                    </Grid>
                </RadioGroup>
            </FormControl>
            <FormControl fullWidth>
                {t('export.exportMode')}
                <RadioGroup
                    name="asyncExport"
                    value={exportState.asyncExport}
                    onChange={exportState.handleChangeAsyncExport}>
                    <Grid container>
                        <Grid item xs={12} sm={6}>
                            <FormControlLabel
                                control={<Radio/>}
                                label={t('export.syncExportMode')}
                                value={false}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControlLabel
                                control={<Radio/>}
                                label={t('export.asyncExportMode')}
                                value={true}
                            />
                        </Grid>
                    </Grid>
                </RadioGroup>
            </FormControl>
            {
                exportState.asyncExport && <WorkgroupAutocomplete value={exportState.workgroupId}
                                                                  onChange={exportState.handleChangeWorkgroupId}
                                                                  MDInputProps={{
                                                                      label: t('export.workgroupLabel'),
                                                                      error: !Boolean(exportState.workgroupId),
                                                                      helperText: Boolean(exportState.workgroupId) ? "" : t('validation:required')
                                                                  }}
                                                                  sx={{mt: 3}}/>
            }
            <Alert severity="info" sx={{mt: 3}}>
                {
                    exportState.asyncExport && t('export.asyncExportModeDescription')
                }
                {
                    !exportState.asyncExport && t('export.syncExportModeDescription')
                }

            </Alert>
        </DialogContent>
        <DialogActions>
            <MDButton onClick={exportState.handleClose} color="info" variant="outlined">
                {t('export.cancel')}
            </MDButton>
            <MDLoadingButton onClick={exportState.handleExport}
                             color="info"
                             variant="gradient"
                             disabled={exportState.asyncExport && !exportState.workgroupId}
                             loading={exportState.isLoading}>
                {t('export.buttonLabel')}
            </MDLoadingButton>
        </DialogActions>
    </>
}


const ExportToolbar = ({models1Filters}) => {
    const {t} = useTranslation(["models1"]);
    const dialogState = useDialog();

    return <MDBox py={2} px={3}>
        <MDLoadingButton variant="outlined"
                         color="info"
                         onClick={dialogState.open}
                         sx={{alignSelf: "flex-start"}}>
            {t('export.buttonLabel')}
        </MDLoadingButton>
        <ExportDialog isOpen={dialogState.isOpen}
                      close={dialogState.close}
                      models1Filters={models1Filters}/>
    </MDBox>
}

export default ExportToolbar;